//const base = 'https://www.kdw123.cn/dgjz/'
//const mobile = 'https://www.kdw123.cn/dgjz/mobile/'
//const mobileEn = 'https://www.kdw123.cn/dgjz/mobileEng/'
//const client = 'https://www.kdw123.cn/dgjzclient/'

const base = 'https://www.ditcc.com/'
const mobile = 'https://www.ditcc.com/mobile/'
const mobileEn = 'https://www.ditcc.com/mobileEng/'
const client = 'https://www.ditcc.com/dgjzclient/'

//const url = 'http://192.168.5.237:8080/dgjz/'
const url = 'https://www.ditcc.com/'
//const url = '/api/'

const webName = '东莞市国际技术信息交互平台'
const webNameEn = 'Dongguan International Technology Information Interaction Platform'
const comPhoneReg = '^((([0,2,3,4,5,6,7,8,9]\\d{3})?(-|\\s*)(\\d{3})?(-|\\s*)\\d{8})|(((\\+(\\d{2}))|([0,2,3,4,5,6,7,8,9]\\d{1}))?(-|\\s*)[0,2,3,4,5,6,7,8,9]\\d{2,3}(-|\\s*)\\d{7,8})|((\\+\\d{2}(-|\\s*))?(\\d{2,3}(-|\\s*))?([1][3,4,5,6,7,8,9][0-9]\\d{8})))$';
const phoneReg = /^1[3|4|5|7|8][0-9]\d{8}$/;
const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
const finCheckId = 34;//项目融资字典ID
export default {
  url:url,
  webName:webName,
  webNameEn:webNameEn,
  base:base,
  mobile:mobile,
  mobileEn:mobileEn,
  client:client,
  comPhoneReg:comPhoneReg,
  phoneReg:phoneReg,
  emailReg:emailReg,
  finCheckId:finCheckId,
}
